import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Feature {
  id: number;
  title: string;
  description: string;
  category?: string;
  media?: string[];
  createdAt: string;
  seen: boolean;
}

interface FeatureUpdatesState {
  features: Feature[];
  unseenCount: number;
  isLoading: boolean;
  lastFetched: number | null;
}

const initialState: FeatureUpdatesState = {
  features: [],
  unseenCount: 0,
  isLoading: false,
  lastFetched: null,
};

export const featureUpdatesSlice = createSlice({
  name: 'featureUpdates',
  initialState,
  reducers: {
    setFeatures: (state, action: PayloadAction<{ features: Feature[]; unseenCount: number }>) => {
      state.features = action.payload.features;
      state.unseenCount = action.payload.unseenCount;
      state.lastFetched = Date.now();
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    markSeen: (state, action: PayloadAction<number[]>) => {
      const seenIds = new Set(action.payload);
      state.features = state.features.map((f) =>
        seenIds.has(f.id) ? { ...f, seen: true } : f,
      );
      state.unseenCount = state.features.filter((f) => !f.seen).length;
    },
    markAllSeen: (state) => {
      state.features = state.features.map((f) => ({ ...f, seen: true }));
      state.unseenCount = 0;
    },
  },
});

export const featureUpdatesActions = featureUpdatesSlice.actions;
export default featureUpdatesSlice.reducer;
